export enum AnalyticsEvents {
  modal_display = 'modal_display',
  card_validation = 'card_validation',
  finishThreeDSValidation = 'finish_threeDS_validation',
  startThreeDSValidation = 'start_threeDS_validation',
  showThreeDSChallenge = 'show_threeDS_challenge',
  hideThreeDSChallenge = 'hide_threeDS_challenge',
  exception = 'exception',
}
